/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const fontSchema = z.object({
	name: z.string(),
	url: z.string(),
});
